import React from "react";

const MovedActionButton = ({ moved = false, disabled = false, onClick }) => (
  <button
    type="button"
    disabled={disabled}
    title={disabled ? "Unavailable while offline" : undefined}
    onClick={onClick}
    className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-semibold transition-all hover:scale-95 disabled:pointer-events-none disabled:opacity-50 ${
      moved
        ? "border-amber-300 bg-amber-50 text-amber-800"
        : "border-canvas-primary bg-canvas-primary/5 text-canvas-primary"
    }`}
  >
    {moved ? "Undo Moved" : "Mark as Moved"}
  </button>
);

export default MovedActionButton;
